import { render, staticRenderFns } from "./SelectLuggageOption.vue?vue&type=template&id=7a48eb81&scoped=true&"
import script from "./SelectLuggageOption.vue?vue&type=script&lang=js&"
export * from "./SelectLuggageOption.vue?vue&type=script&lang=js&"
import style0 from "./SelectLuggageOption.vue?vue&type=style&index=0&id=7a48eb81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a48eb81",
  null
  
)

/* custom blocks */
import block0 from "./SelectLuggageOption.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRow,VSelect})
